<template>
    <div class="page">
        <Section>
            <h1 class="text-h3 font-weight-bold mb-8">{{ t('faq.title') }}</h1>
            <v-expansion-panels variant="accordion">
                <v-expansion-panel
                    v-for="(item, i) in items"
                    :key="i"
                    :title="item.q"
                    :text="item.a"
                    eager
                />
            </v-expansion-panels>
        </Section>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue'
    import Section from '@/components/Section.vue'
    import { useTranslations } from '@/composables/useTranslations'
    import { useSEO } from '@/composables/useSEO'

    const { t, get } = useTranslations()
    useSEO({
        title: () => t('seo.faq.title'),
        description: () => t('seo.faq.description'),
    })

    interface FaqItem {
        q: string
        a: string
    }
    const items = computed<FaqItem[]>(() => get<FaqItem[]>('faq.items') ?? [])
</script>

<style scoped>
    .page {
        padding-top: 80px;
    }

    /* Highlight the open panel so it stands out from the collapsed ones. */
    .page :deep(.v-expansion-panel--active) {
        background: rgba(var(--v-theme-primary), 0.07);
        border-left: 3px solid rgb(var(--v-theme-primary));
    }

    .page :deep(.v-expansion-panel-title--active) {
        color: rgb(var(--v-theme-primary));
        font-weight: 600;
    }
</style>
